import { Observable } from 'rxjs';
import { ChatDetail, ChatSummary, CreateChatPayload } from '../models/chat.model';
import { Message, PaymentRetryStatus, ReportStatus } from '../models/message.model';

export interface ReportContext { messageId: string; agentCode: string; }
export type DeliveryTarget = 'REQUESTER' | 'CASH_DESK';
export interface ReportSubmission { id: string; text: string; reportStatus: ReportStatus; }

export interface PaymentRetryDetails {
  paymentDate: string;
  paymentAmount: number;
  paymentOperationNumber: string;
}

export interface PaymentRetryPayload extends PaymentRetryDetails {
  clientMessageId: string;
}

export interface PaymentRetryResponse {
  id: string;
  text: string;
  paymentRetryStatus: PaymentRetryStatus;
  userMessage?: Omit<Message, 'userId'> & { userId?: string };
}

export abstract class ChatRepositoryPort {
  abstract list(): Observable<ChatSummary[]>;
  abstract getById(chatId: string | number): Observable<ChatDetail | null>;
  abstract create(chat: CreateChatPayload): Observable<ChatDetail>;
  abstract getReportContext(chatId: string | number, messageId: string): Observable<ReportContext>;
  abstract submitReport(chatId: string | number, messageId: string,
    agentCode: string, deliveryTarget: DeliveryTarget): Observable<ReportSubmission>;
  abstract submitPaymentRetry(chatId: string | number, botMessageId: string,
    payload: PaymentRetryPayload): Observable<PaymentRetryResponse>;
}
